import { FilePlus2 } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SopManagementPage } from './pages/SopManagementPage'
import { SopManageReaderPage } from './pages/SopManageReaderPage'
import { SopEditorPage } from './pages/SopEditorPage'

/**
 * SOP Management — authoring surface for Standard Operating Procedures.
 * Create SOPs from scratch or import existing PDFs, edit, publish, and
 * archive. Admin + operations only (operations_logistics inherits the
 * same authoring rights as operations — see rbac.py). The read-only
 * /sop-library surface is a separate module every internal role sees;
 * same split as cofa-documents/cofa-pipeline.
 */
export default defineModule({
  id: 'sop-management',
  name: 'SOP Management',
  shortName: 'SOP Admin',
  icon: FilePlus2,
  navSection: 'admin',
  navOrder: 25,
  urlNamespace: '/sop-manage',
  routes: [
    { path: '/', element: SopManagementPage, label: 'SOP Management' },
    { path: '/$sopId', element: SopManageReaderPage, label: 'SOP' },
    { path: '/$sopId/edit', element: SopEditorPage, label: 'Edit SOP' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',
  keyboardShortcut: 'g s m',
  commandPaletteEntries: [
    {
      label: 'Go to SOP Management',
      keywords: ['sop', 'procedure', 'author', 'upload', 'publish', 'admin'],
      path: '/',
      group: 'modules',
      shortcut: 'g s m',
    },
  ],
})
